var exports = {
  "k": "x4c3adb35--da23f8--container",
};

module.exports = exports;
